const eliteWorkouts = [
  {
    id: 'elite-1',
    name: 'Elite Performance & Recovery',
    tier: 'elite',
    duration: 45,
    level: 'Advanced',
    focusArea: 'Performance',
    description: 'High-intensity training with professional guidance and recovery protocols',
    thumbnailUrl: 'https://images.unsplash.com/photo-1561214115-f2f134cc4912?auto=format&fit=crop&w=500&q=60',
    exercises: [
      {
        id: 'weighted-squats',
        name: 'Weighted Squats',
        description: 'Squats with added resistance for maximum strength',
        sets: 5,
        reps: 12,
        restSeconds: 90,
        focusAreas: ['Legs', 'Core'],
        // videoUrl: 'https://player.vimeo.com/video/824804225?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/weighted-squats-diagram.svg',
        instructions: 'Stand with feet shoulder-width apart, hold weights at shoulder level, squat down keeping knees behind toes, then return to standing position.'
      },
      {
        id: 'diamond-pushups',
        name: 'Diamond Push-ups',
        description: 'Advanced push-ups for upper body power',
        sets: 4,
        reps: 15,
        restSeconds: 75,
        focusAreas: ['Chest', 'Arms'],
        // videoUrl: 'https://player.vimeo.com/video/824804226?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/diamond-pushup-diagram.svg',
        instructions: 'Form a diamond shape with your hands under your chest, lower your body while keeping it straight, then push back up.'
      }
    ],
    focusAreas: ['Performance', 'Recovery'],
    estimatedDuration: 45
  },
  {
    id: 'arthritis-management',
    name: 'Arthritis Management Program',
    tier: 'elite',
    duration: 25,
    level: 'Beginner',
    focusArea: 'Mobility',
    description: 'Gentle, slow-tempo strength work that helps you ease joints through pain-free ranges while building the muscles that support them.',
    thumbnailUrl: 'https://res.cloudinary.com/dpy2y99bz/image/upload/c_fill,g_face,h_600,w_800/v1762691060/image_4_lnsmrm.jpg',
    exercises: [
      {
        id: 'gentle-arm-circles',
        name: 'Gentle Arm Circles',
        description: 'Slow, controlled arm circles to improve shoulder mobility',
        sets: 2,
        reps: 10,
        restSeconds: 30,
        focusAreas: ['Shoulders', 'Mobility'],
        // videoUrl: 'https://player.vimeo.com/video/824804227?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/arm-circles-diagram.svg',
        instructions: 'Stand or sit comfortably. Glide your arms through small circles for a slow 5-count forward and a 5-count back, staying in a pain-free range. Focus on relaxed shoulders and smooth breathing.'
      },
      {
        id: 'seated-leg-extensions',
        name: 'Seated Leg Extensions',
        description: 'Gentle leg extensions to strengthen quadriceps',
        sets: 3,
        reps: 12,
        restSeconds: 45,
        focusAreas: ['Legs', 'Strength'],
        // videoUrl: 'https://player.vimeo.com/video/824804228?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/leg-extensions-diagram.svg',
        instructions: 'Sit tall with feet flat. Press one leg out over a slow 5-count, pause briefly, then lower on another 5-count. Stop before discomfort and keep tension in the thigh, not the knee joint.'
      },
      {
        id: 'wrist-flexibility',
        name: 'Wrist Flexibility Exercises',
        description: 'Gentle wrist stretches and movements',
        sets: 2,
        reps: 8,
        restSeconds: 30,
        focusAreas: ['Arms', 'Flexibility'],
        // videoUrl: 'https://player.vimeo.com/video/824804229?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/wrist-flexibility-diagram.svg',
        instructions: 'Hold one arm out with the palm down and glide the wrist up over four slow counts, then down over four counts. Repeat side-to-side and with palm up, pausing if you feel joint pressure.'
      }
    ],
    focusAreas: ['Joint Health', 'Mobility', 'Pain Management', 'Slow Strength'],
    trainingGuidelines: [
      'Move on a controlled 5-second up / 5-second down tempo to let muscles—rather than joints—do the work.',
      'Work only in pain-free ranges and pause immediately if discomfort becomes sharp or unstable.',
      'Schedule 48 hours of rest between arthritis strength sessions to allow joints to recover.'
    ],
    estimatedDuration: 25,
    difficulty: 'Beginner',
    specialized: true
  },
  {
    id: 'balance-training',
    name: 'Balance & Fall Prevention',
    tier: 'elite',
    duration: 30,
    level: 'All Levels',
    focusArea: 'Balance',
    description: 'Steady, slow-tempo balance drills that train ankles, hips, and core without jolting sensitive joints—perfect for confidence building and fall prevention.',
    thumbnailUrl: 'https://res.cloudinary.com/dpy2y99bz/image/upload/c_fill,g_face,h_600,w_800/v1762693112/image_5_lojspe.jpg',
    exercises: [
      {
        id: 'single-leg-stand',
        name: 'Single Leg Stand',
        description: 'Stand on one leg while holding onto support',
        sets: 3,
        reps: 30,
        restSeconds: 60,
        focusAreas: ['Balance', 'Core'],
        // videoUrl: 'https://player.vimeo.com/video/824804230?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/single-leg-stand-diagram.svg',
        instructions: 'Stand tall beside a countertop or railing. Hover one foot off the floor and hold for a slow 3-count in, 3-count out breathing pattern. Lightly tap the surface if balance wobbles, then switch legs after up to 30 seconds.'
      },
      {
        id: 'heel-to-toe-walk',
        name: 'Heel-to-Toe Walk',
        description: 'Walk in a straight line placing heel to toe',
        sets: 2,
        reps: 20,
        restSeconds: 45,
        focusAreas: ['Balance', 'Coordination'],
        // videoUrl: 'https://player.vimeo.com/video/824804231?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/heel-to-toe-diagram.svg',
        instructions: 'Line up heel-to-toe near a wall, sliding the front foot forward over a slow 4-count. Keep eyes forward, core engaged, and brush the wall lightly for support as needed. Continue for 10 smooth steps each direction.'
      },
      {
        id: 'side-leg-raises',
        name: 'Side Leg Raises',
        description: 'Lift leg to the side while holding support',
        sets: 3,
        reps: 10,
        restSeconds: 45,
        focusAreas: ['Legs', 'Balance'],
        // videoUrl: 'https://player.vimeo.com/video/824804232?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/side-leg-raise-diagram.svg',
        instructions: 'Face a sturdy chair, lift one leg out to the side over a 4-count, pause briefly, then lower on another 4-count. Keep hips level, core braced, and stop before the pelvis tips. Repeat evenly on both sides.'
      }
    ],
    focusAreas: ['Balance', 'Coordination', 'Fall Prevention', 'Steady Strength'],
    trainingGuidelines: [
      'Set up near a stable surface so you can feather-touch support at any time without disrupting posture.',
      'Use 3- to 4-second tempos for lifts and transitions; the slower pace teaches your ankles and hips to react calmly.',
      'Practice two to three non-consecutive days per week, ending the session if balance falters due to fatigue.'
    ],
    estimatedDuration: 30,
    difficulty: 'All Levels',
    specialized: true
  },
  {
    id: 'post-surgery-recovery',
    name: 'Post-Surgery Recovery',
    tier: 'elite',
    thumbnailUrl: 'https://res.cloudinary.com/dpy2y99bz/image/upload/c_fill,g_face,h_600,w_800/v1762693562/image_6_gjm9xm.jpg',
    description: 'Controlled, slow-tempo drills that reintroduce movement post-surgery—strengthening support muscles without jolting sensitive tissue.',
    exercises: [
      {
        id: 'ankle-pumps',
        name: 'Ankle Pumps',
        description: 'Gentle ankle movements to improve circulation',
        sets: 3,
        reps: 15,
        restSeconds: 30,
        focusAreas: ['Legs', 'Circulation'],
        // videoUrl: 'https://player.vimeo.com/video/824804233?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/ankle-pumps-diagram.svg',
        instructions: 'While seated or lying down, press your toes away over a calm 4-count, pause, then draw them back toward you on another 4-count. Keep the range pain-free and focus on steady breathing.'
      },
      {
        id: 'gentle-knee-bends',
        name: 'Gentle Knee Bends',
        description: 'Slow, controlled knee bends with support',
        sets: 2,
        reps: 8,
        restSeconds: 60,
        focusAreas: ['Legs', 'Mobility'],
        // videoUrl: 'https://player.vimeo.com/video/824804234?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/knee-bends-diagram.svg',
        instructions: 'Hold a chair or walker, glide into a mini squat over a 5-count, pause, then rise over another 5-count. Stop the motion before discomfort and keep weight even through the feet.'
      },
      {
        id: 'shoulder-rolls',
        name: 'Shoulder Rolls',
        description: 'Gentle shoulder movements to maintain mobility',
        sets: 2,
        reps: 10,
        restSeconds: 30,
        focusAreas: ['Shoulders', 'Mobility'],
        // videoUrl: 'https://player.vimeo.com/video/824804235?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/shoulder-rolls-diagram.svg',
        instructions: 'Sit or stand tall. Draw shoulders forward, up, back, and down using smooth 3-count segments in each direction. Pause if the incision area or joint feels irritated before reversing.'
      }
    ],
    focusAreas: ['Rehabilitation', 'Mobility', 'Recovery', 'Controlled Strength'],
    estimatedDuration: 20,
    difficulty: 'Beginner',
    trainingGuidelines: [
      'Move on gentle 4- to 5-second tempos so healing tissue experiences smooth, predictable loading.',
      'Stay within surgeon-approved ranges and stop if you feel sharp, pulling, or unstable sensations.',
      'Schedule a rest or light-walking day between recovery strength sessions during early rehab.'
    ],
    specialized: true
  },
  {
    id: 'cardiac-rehabilitation',
    name: 'Cardiac Rehabilitation',
    tier: 'elite',
    thumbnailUrl: 'https://res.cloudinary.com/dpy2y99bz/image/upload/c_fill,g_face,h_600,w_800/v1762694317/image_7_krj0hm.jpg',
    description: 'Breath-led, low-impact conditioning that builds cardiovascular confidence with slow pacing and constant intensity checks.',
    exercises: [
      {
        id: 'slow-walking',
        name: 'Slow Walking',
        description: 'Gentle walking at a comfortable pace',
        sets: 1,
        reps: 10,
        restSeconds: 0,
        focusAreas: ['Cardiovascular', 'Endurance'],
        // videoUrl: 'https://player.vimeo.com/video/824804236?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/walking-diagram.svg',
        instructions: 'Walk at a conversational pace, inhaling for three steps and exhaling for three. Check perceived exertion every minute, pausing immediately if breathing becomes laboured or symptoms appear.'
      },
      {
        id: 'seated-marching',
        name: 'Seated Marching',
        description: 'March in place while seated',
        sets: 3,
        reps: 20,
        restSeconds: 60,
        focusAreas: ['Legs', 'Cardiovascular'],
        // videoUrl: 'https://player.vimeo.com/video/824804237?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/seated-marching-diagram.svg',
        instructions: 'Sit tall and lift one knee to hip height over a 3-count, lower on a 3-count, and alternate legs. Keep breath smooth and stop if heart rate climbs beyond your care-team limits.'
      },
      {
        id: 'arm-raises',
        name: 'Gentle Arm Raises',
        description: 'Slow arm raises to shoulder level',
        sets: 2,
        reps: 12,
        restSeconds: 45,
        focusAreas: ['Arms', 'Mobility'],
        // videoUrl: 'https://player.vimeo.com/video/824804238?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/arm-raises-diagram.svg',
        instructions: 'Sit or stand with arms at sides. Float both hands to shoulder height over four slow counts, hold one breath, then descend over four counts. Keep shoulders relaxed and stop shy of strain.'
      }
    ],
    focusAreas: ['Cardiovascular', 'Heart Health', 'Endurance', 'Breath Control'],
    estimatedDuration: 25,
    difficulty: 'Beginner',
    trainingGuidelines: [
      'Use conversational pacing and rate of perceived exertion to stay in heart-safe zones approved by your clinician.',
      'Pair every movement with a steady inhale/exhale rhythm to prevent breath holding and sudden spikes.',
      'Log heart-rate or symptom responses after each session so your care team can adjust intensity when appropriate.'
    ],
    specialized: true
  },
  {
    id: 'diabetes-management',
    name: 'Diabetes Management',
    tier: 'elite',
    thumbnailUrl: 'https://res.cloudinary.com/dpy2y99bz/image/upload/c_fill,g_face,h_600,w_800/v1762694651/image_8_ws2tup.jpg',
    description: 'Metabolic-friendly walking and strength intervals performed at a calm tempo to support glucose control without joint stress.',
    exercises: [
      {
        id: 'brisk-walking',
        name: 'Brisk Walking',
        description: 'Walking at a moderate pace to help manage blood sugar',
        sets: 1,
        reps: 15,
        restSeconds: 0,
        focusAreas: ['Cardiovascular', 'Endurance'],
        // videoUrl: 'https://player.vimeo.com/video/824804239?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/brisk-walking-diagram.svg',
        instructions: 'Walk at a steady pace you can maintain for 15 minutes, breathing in for three steps and out for three. Test glucose as advised before/after and carry fast-acting carbs if needed.'
      },
      {
        id: 'bodyweight-squats',
        name: 'Bodyweight Squats',
        description: 'Squats to build strength and improve metabolism',
        sets: 3,
        reps: 12,
        restSeconds: 60,
        focusAreas: ['Legs', 'Strength'],
        // videoUrl: 'https://player.vimeo.com/video/824804240?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/bodyweight-squats-diagram.svg',
        instructions: 'Stand tall, hinge hips back over a 4-count, pause, then rise over another 4-count. Keep knees in line with toes and focus on the thigh muscles rather than speed.'
      },
      {
        id: 'wall-pushups',
        name: 'Wall Push-ups',
        description: 'Push-ups against wall for upper body strength',
        sets: 3,
        reps: 10,
        restSeconds: 45,
        focusAreas: ['Chest', 'Arms'],
        // videoUrl: 'https://player.vimeo.com/video/824804241?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/wall-pushups-diagram.svg',
        instructions: 'Stand an arm’s length from a wall. Lower your chest toward the wall on a 4-count, pause, then press back to start on a 4-count. Keep breath flowing and wrists stacked under shoulders.'
      }
    ],
    focusAreas: ['Metabolic Health', 'Strength', 'Cardiovascular', 'Slow Strength'],
    estimatedDuration: 30,
    difficulty: 'All Levels',
    trainingGuidelines: [
      'Check glucose before and after sessions, fuelling as directed by your healthcare team.',
      'Use 4-second lowering and lifting tempos on strength moves to maximise muscle engagement and insulin sensitivity.',
      'Alternate walking intervals with strength work two to three times per week, leaving a recovery day between intense sessions.'
    ],
    specialized: true
  },
  {
    id: 'osteoporosis-strength',
    name: 'Osteoporosis Strength Training',
    tier: 'elite',
    thumbnailUrl: 'https://res.cloudinary.com/dpy2y99bz/image/upload/c_fill,g_face,h_600,w_800/v1762695252/image_9_z6blwj.jpg',
    description: 'Bone-loading strength work performed with slow, deliberate reps so the skeleton absorbs stimulus without jerky impact.',
    exercises: [
      {
        id: 'weight-bearing-squats',
        name: 'Weight-Bearing Squats',
        description: 'Squats to improve bone density in legs',
        sets: 3,
        reps: 10,
        restSeconds: 60,
        focusAreas: ['Legs', 'Bone Health'],
        // videoUrl: 'https://player.vimeo.com/video/824804242?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/weight-bearing-squats-diagram.svg',
        instructions: 'Stand with feet hip-width. Lower into a chair-height squat over a 4-count, pause to feel heels grounded, then stand tall over another 4-count. Keep spine long and weights close to the body.'
      },
      {
        id: 'standing-arm-raises',
        name: 'Standing Arm Raises',
        description: 'Arm raises with light weights for upper body bone health',
        sets: 3,
        reps: 12,
        restSeconds: 45,
        focusAreas: ['Arms', 'Bone Health'],
        // videoUrl: 'https://player.vimeo.com/video/824804243?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/arm-raises-weights-diagram.svg',
        instructions: 'Hold light weights. Lift arms to shoulder height over a 4-count, pause for one breath, then lower on a 4-count. Avoid shrugging shoulders and stop just before joints feel strained.'
      },
      {
        id: 'heel-raises',
        name: 'Heel Raises',
        description: 'Standing on toes to strengthen calves and improve balance',
        sets: 3,
        reps: 15,
        restSeconds: 45,
        focusAreas: ['Legs', 'Balance'],
        // videoUrl: 'https://player.vimeo.com/video/824804244?h=8c0e0e0e0e', // Will be added later
        diagramUrl: '/images/exercises/heel-raises-diagram.svg',
        instructions: 'Hold a counter lightly, rise to your toes over a 3-count, pause, then lower heels over another 3-count. Keep knees softly bent and distribute weight evenly across the forefoot.'
      }
    ],
    focusAreas: ['Bone Health', 'Strength', 'Balance', 'Slow Strength'],
    estimatedDuration: 35,
    difficulty: 'Intermediate',
    trainingGuidelines: [
      'Aim for two to three sessions per week with at least one rest day between to allow bone remodelling.',
      'Use a 4-second lifting and lowering tempo to apply consistent loading without impact.',
      'Prioritise posture—long spine, shoulders back, and knees tracking over toes—to distribute forces safely.'
    ],
    specialized: true
  }
];

export { eliteWorkouts };
